import React, { useEffect, useRef, useState } from "react";
import classes from "./HistoryOverlay.module.css";
import { RxCross2 } from "react-icons/rx";
import { IoChevronDown } from "react-icons/io5";
import FileCorruptIcon from "../../icon/FileCorruptIcon";
import CrownIcon from "../../icon/CrownIcon";
import MedalIcon from "../../icon/MedalIcon";
import HonourStarIcon from "../../icon/HonourStarIcon";
import { env } from "../../constants/env";

const months = ["August"];
const currentYear = new Date().getFullYear();

const renderRankIcon = (rank) => {
  switch (rank) {
    case 1:
      return <CrownIcon size="18" />;
    case 2:
      return <MedalIcon size="18" />;
    case 3:
      return <HonourStarIcon size="18" />;
    default:
      return <span></span>;
  }
};

const HistoryOverlay = ({ onClose }) => {
  const [selected, setSelected] = useState(months[0]);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Fetch leaderboard when month changes
  // useEffect(() => {
  //   const fetchHistory = async () => {
  //     try {
  //       setLoading(true);
  //       const res = await fetch(
  //         `${env.apiUrl}/api/leaderboard?month=${selected}&year=${currentYear}`
  //       );
  //       if (!res.ok) throw new Error("Failed to fetch leaderboard");
  //       const data = await res.json();

  //       // Top 6 only + highlight first
  //       setHistory(
  //         (data.rankings || [])
  //           .slice(0, 6)
  //           .map((entry, idx) => ({ ...entry, highlight: idx === 0 }))
  //       );
  //     } catch (err) {
  //       console.error("Failed to load history:", err);
  //       setHistory([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchHistory();
  // }, [selected]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (month) => {
    setSelected(month);
    setOpen(false);
  };

  return (
    <div className={classes.overlay}>
      <div className={classes.modalWrapper}>
        <div className={classes.header}>
          <h4>History</h4>
          <button onClick={onClose} className={classes.closeBtn}>
            <RxCross2 size={20} />
          </button>
        </div>
        {loading ? (
          <div
            className={`d-flex flex-column gap-4 align-items-center justify-content-center ${classes.emptyTable}`}
          >
            <div className={classes.loading}>Loading...</div>
          </div>
        ) : history.length > 0 ? (
          <div className={classes.modal}>
            <div className={classes.tableHeader}>
              <div className="d-flex align-items-center gap-3">
                <h4>Funded traders</h4>

                {/* Custom Dropdown */}
                <div className={classes.dropdownWrapper}>
                  <button
                    className={`d-flex align-items-center justify-content-between gap-1 ${classes.dropdownBtn}`}
                    onClick={() => setOpen(!open)}
                  >
                    {selected} <IoChevronDown />
                  </button>
                  {open && (
                    <ul className={classes.dropdownMenu} ref={dropdownRef}>
                      {months.map((month) => (
                        <li
                          key={month}
                          className={`${classes.dropdownItem} ${
                            month === selected ? classes.activeItem : ""
                          }`}
                          onClick={() => handleSelect(month)}
                        >
                          {month}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>

              <h4>Account size</h4>
            </div>

            <div className={classes.list}>
              {history.map((entry) => (
                <div
                  key={entry.rank}
                  className={`${classes.row} ${
                    entry.highlight ? classes.highlightRow : ""
                  }`}
                >
                  <div className={classes.left}>
                    <div className="d-flex align-items-center">
                      {renderRankIcon(entry.rank)}
                      <span
                        className={`${classes.rank} ${
                          entry.rank === 1
                            ? classes.topRank
                            : entry.rank === 2
                            ? classes.secondRank
                            : entry.rank === 3
                            ? classes.thirdRank
                            : classes.normalRank
                        }`}
                      >
                        {entry.rank}
                      </span>
                    </div>
                    <span>{entry.username}</span>
                  </div>
                  <div className={classes.right}>
                    {entry.equity?.toLocaleString?.() || entry.equity}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div
            className={`d-flex flex-column gap-4 align-items-center justify-content-center ${classes.emptyTable}`}
          >
            <FileCorruptIcon />
            <h3>No data to display</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistoryOverlay;
